import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { ExportToCsv } from "export-to-csv";
import filters from "./filters";
import html2canvas from "html2canvas";

const states = [];

const Libs = {
  registerState(name) {
    states.push(name);
  },
  reduzPalavra(str) {
    if (typeof str !== "string" || str.length === 0) {
      return ""; // Retorna uma string vazia se o input não for válido
    }

    return str.slice(0, 3);
  },
  getStates() {
    return states;
  },
  mountedArrayJson: (array, data, keys) => {
    if (!array.key.includes(data[keys[0]])) {
      let x = array.data.length;
      let js = {};
      js[keys[0]] = data[keys[0]];
      js[keys[1]] = data[keys[1]];
      js.index = x;
      array.key.push(data[keys[0]]);
      array.data.push(js);
    }
  },
  baseUrlview: "http://localhost:8080",
  basedir: () => {
    var url_atual = window.location.href;
    let index_ = url_atual.indexOf("localhost");
    let url_ = "";
    if (index_ == -1) {
      url_ = "/avaliacao2023/";
    } else {
      url_ = "";
    }

    return url_;
  },
  setToggle: (variavel) => {
    if (variavel == true) {
      return false;
    } else {
      return true;
    }
  },
  primeiraLetraDeCadaPalavra: (frase) => {
    // Divide a frase em palavras usando o espaço como separador
    const palavras = frase.split(" ");

    // Inicializa uma variável para armazenar as primeiras letras
    let primeirasLetras = "";

    // Itera pelas palavras e pega a primeira letra de cada uma
    for (const palavra of palavras) {
      if (palavra.length > 0) {
        // Verifica se a palavra não é vazia
        primeirasLetras += palavra[0]; // Adiciona a primeira letra à variável
      }
    }

    return primeirasLetras;
  },

  // basedir:'/dev',
  //  baseUrlview: 'https://g-ale.net/dev',
  getToken: () => {
    let tk = localStorage.getItem("token");
    if (tk == null) {
      tk = "";
    }
    return tk;
  },
  UltimoIndexClasse: (classe) => {
    let elementos = document.querySelectorAll(`.${classe}`);
    return elementos.length - 1;
  },
  addHtml: (idPai, classeFilha, tipo) => {
    let elementoFilho = document.createElement(tipo);
    let node = document.createTextNode("this is new");
    elementoFilho.classList.add(classeFilha);
    elementoFilho.style.height = "910px";
    elementoFilho.appendChild(node);

    let pdfDestino = document.getElementById(idPai);
    pdfDestino.appendChild(elementoFilho);
  },
  parearArray: (arrayOrigem, arrayKey, keyValidar) => {
    let ar = [];
    let v = [];
    arrayOrigem.map((i) => {
      let j = {};
      if (!v.includes(i[keyValidar])) {
        arrayKey.map((k) => {
          j[k] = i[k];
        });
        ar.push(j);
        v.push(i[keyValidar]);
      }
    });
    return ar;
  },
  objectToQueryString: (obj) => {
    var str = [];
    let keys = Object.keys(obj);
    keys.forEach((iten) => {
      str.push(`${iten}=${obj[iten]}`);
    });

    return str.join("&");
  },
  relogio: () => {
    let data = new Date();
    let hor = data.getHours();
    let min = data.getMinutes();
    let seg = data.getSeconds();

    if (hor < 10) {
      hor = "0" + hor;
    }
    if (min < 10) {
      min = "0" + min;
    }
    if (seg < 10) {
      seg = "0" + seg;
    }

    let horas = hor + ":" + min + ":" + seg;

    return horas;
  },
  timestampCronologico: (dif) => {
    var xa = 3.168808781402895 * Math.pow(10, -8);
    var xm = 3.803 * Math.pow(10, -7);
    var xd = 1.2 * Math.pow(10, -5);
    var ano = dif * xa;
    var rest = parseFloat(ano) - parseInt(ano);
    var rest1 = (rest * dif) / ano;
    var mes = rest1 * xm;
    var rest2 = parseFloat(mes) - parseInt(mes);
    rest2 = (rest2 * rest1) / mes;
    var dia = rest2 * xd;
    var ar = {};
    ar["ano"] = parseInt(ano);
    ar["mes"] = parseInt(mes);
    ar["dia"] = parseInt(dia);
    return ar;
  },
  validemail: (email) => {
    return /.+@.+\..+/.test(email);
  },
  /*substitui valor de um json compara as chaves de json e settigs ,
    json recebe valor de settings caso ambos tenham a mesma chave*/
  jsonReplaceValue: (json, settings) => {
    if (settings == null) return json;

    let key = Object.keys(json);
    key.forEach((iten) => {
      if (typeof settings[iten] != "undefined") {
        json[iten] = settings[iten];
      }
    });
    return json;
  },
  jsonGetWithvalues(origem) {
    let destino = {};
    for (let chave in origem) {
      let v = origem[chave].trim();
      if (v.length > 0) {
        destino[chave] = v;
      }
    }
    return destino;
  },
  timestampToHMS: (timestap) => {
    let js = { hours: "00", minutes: "00", seconds: "" };
    let hours = Math.floor(timestap / 3600);
    parseInt(hours) < 10 ? (hours = `0${hours}`) : null;
    timestap %= 3600;
    let minutes = Math.floor(timestap / 60);
    parseInt(minutes) < 10 ? (minutes = `0${minutes}`) : null;
    let seconds = Number(timestap % 60).toFixed(0);
    parseInt(seconds) < 10 ? (seconds = `0${seconds}`) : null;
    js.hours = hours;
    js.minutes = minutes;
    js.seconds = seconds;
    return js;
  },

  getPayloadToken: (attr = "") => {
    let token = localStorage.getItem("token");
    if (token) {
      let array_ = token.split(".");
      let json = JSON.parse(atob(array_[1]));
      if (attr == "") {
        return json;
      } else {
        return json[attr];
      }
    } else {
      return null;
    }
  },
  /* keys é um array de chaves e csaso json tenha aquela chave é reornado , 
    retorna um novo json com as chaves desejadas*/
  partialJson: (keys, json) => {
    let newjson = {};
    keys.forEach((item) => {
      if (typeof json[item] != "undefined") {
        newjson[item] = json[item];
      }
    });
    return newjson;
  },
  sortJson: (obj = { chave: "", ordem: "", json: "", type: "" }) => {
    var ord = "ASC";
    var t = "s";
    if (obj.ordem) {
      if (obj.ordem === 0) {
        ord = "ASC";
      } else {
        ord = "DESC";
      }
    }
    if (obj.type) {
      t = obj.type;
    }
    let js = [];
    js = obj.json.sort(function (a, b) {
      var x = a[obj.chave];
      var y = b[obj.chave];
      if (ord === "ASC") {
        if (t === "s") {
          return x < y ? -1 : x > y ? 1 : 0;
        }
        if (t === "n") {
          return parseInt(x) < parseInt(y) ? -1 : parseInt(x) > parseInt(y) ? 1 : 0;
        }
      }
      if (ord === "DESC") {
        if (t === "s") {
          return x > y ? -1 : x < y ? 1 : 0;
        }
        if (t === "n") {
          return parseInt(x) > parseInt(y) ? -1 : parseInt(x) < parseInt(y) ? 1 : 0;
        }
      }
    });
    return js;
  },
  openWindow: (json, router) => {
    let root = router.resolve({
      name: json.name,
      query: json.query,
    });
    let tamanhoW = screen.width;
    let tamanhoh = screen.height;

    window
      .open(
        root.href,
        json.name,
        "left=0,top=0,width=" +
          tamanhoW +
          ",height=" +
          tamanhoh +
          " ,directories=no,scrollbars=yes,location=no,menubar=no,resizable=no,status=no,titlebar=yes,toolbar=no,fullscreen=no"
      )
      .focus();
  },
  toggle(variavel) {
    if (variavel == true) {
      return false;
    } else {
      return true;
    }
  },
  pegarModuloURL(router = false, clear = false) {
    let url = router.currentPath?.path || location.pathname;
    let modulo = url.split("/")[1] || false;
    if (!modulo) return false;
    let modulos = {
      administrativo: "Administrativo",
      nutricionista: "Nutricionista",
      compras: "Compras",
      logistico: "Logistico Alimentação",
      "alimentacao-instituicao": "Alimentação Instituição",
      "logistico-instituicao": "Logistico Instituição",
    };
    if (clear) return modulo;
    return modulos[modulo] || false;
  },
  /* pega os dados chave valor de uma url ?id=1 reirna {id:1}   */
  getDataUrl: function (token = "token") {
    let urli = location.search.slice(1);
    var data = {};
    var query = decodeURIComponent(urli);
    urli.length === 0 ? (urli = window.parent.location.search.slice(1)) : null;

    if (query.length > 0) {
      var partes = query.split("&");

      partes.forEach(function (parte) {
        var chaveValor = parte.split("=");
        var chave = chaveValor[0];
        var valor = chaveValor[1];
        data[chave] = valor;
      });
    }
    if (localStorage.getItem(token) != null) {
      let ty = localStorage.getItem(token).split(".");
      let js = JSON.parse(atob(ty[1]));

      data.fkusuario = js.id;
      data.user = js.usuario;
    }
    return data;
  },
  clearJsonValue: (json) => {
    let keys = Object.keys(json);
    keys.forEach((iten) => {
      json[iten] = "";
    });
    return json;
  },
  getJsonWithValues(json) {
    let keys = Object.keys(json);
    let js = {};
    keys.forEach((iten) => {
      if (String(json[iten]).length > 0) {
        js[iten] = json[iten];
      }
    });
    return js;
  },
  replaccNumber: (n) => {
    return n.prototype.replaceAll(".", "");
  },
  validarCpf: (cpf) => {
    cpf = cpf.replace(/\D/g, "");
    if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
    var result = true;
    [9, 10].forEach(function (j) {
      var soma = 0,
        r;
      cpf
        .split(/(?=)/)
        .splice(0, j)
        .forEach(function (e, i) {
          soma += parseInt(e) * (j + 2 - (i + 1));
        });
      r = soma % 11;
      r = r < 2 ? 0 : 11 - r;
      if (r != cpf.substring(j, j + 1)) result = false;
    });
    return result;
  },
  validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, "");
    if (cnpj == "") return false;
    if (cnpj.length != 14) return false;

    if (
      cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999"
    )
      return false;

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;

    return true;
  },
  forcaSenha: (senha) => {
    let forca = 0;

    senha == null ? (senha = "") : null;
    senha.length > 7 ? (forca += 10) : null;
    senha.length > 7 && /[a-z]+/.test(senha) ? (forca += 10) : null;
    senha.length > 7 && /[A-Z]+/.test(senha) ? (forca += 10) : null;
    senha.length > 7 && /[0-9]+/.test(senha) ? (forca += 10) : null;
    senha.length > 7 && /[@#$%&*;:]+/.test(senha) ? (forca += 10) : null;
    senha.length > 7 && /[\s]+/.test(senha) ? (forca += 15) : null;
    senha.length > 15 && forca >= 50 ? (forca += 15) : null;
    senha.length > 25 && forca >= 50 ? (forca += 20) : null;
    senha.length == 0 ? (forca = 0) : null;
    if (senha.length < 8 && senha.length > 0) {
      forca = senha.length * 2;
    }
    return forca;
  },
  jsonTranferValue: (origem, destino) => {
    if (origem instanceof Object && destino instanceof Object) {
      let keys = Object.keys(destino);
      keys.map((iten) => {
        if (iten in origem) destino[iten] = origem[iten];
      });
    }
    return null;
  },
  jsonClone: (json) => {
    let js = {};
    if (json instanceof Object) {
      let keys = Object.keys(json);
      keys.map((iten) => {
        js[iten] = json[iten];
      });
    }
    return js;
  },
  /**
   *
   * @param {*} array array a ser clonado
   * @param {*} init objeto para ser inserido no inicio chave 0 zero no array
   * @returns retormna um novo array
   */
  arrayClone(array, init = {}) {
    let y = Object.keys(init);
    let ar = [];
    if (parseInt(y) > 0) {
      ar.push(init);
    }
    if (Array.isArray(array)) {
      array.map((it) => {
        let j = this.jsonClone(it);
        ar.push(j);
      });
    }
    return ar;
  },
  filterArrayExists: (arrayorigem = [], arrayincludes = [], keyorigem, keyincludes) => {
    let keys = [];
    arrayincludes.map((iten) => {
      keys.push(iten[keyincludes]);
    });
    let arrayfinal = arrayorigem.filter((iten) => {
      if (!keys.includes(iten[keyorigem])) {
        return iten;
      }
    });
    return arrayfinal;
  },
  prepareDiasCardapio: (arr) => {
    let f = [];
    let compare = [];
    arr.map((item) => {
      let j = {};
      let index = compare.indexOf(item.id_refeicao);
      if (index == -1) {
        j.id_refeicao = item.id_refeicao;
        j.refeicao = item.refeicao;
        j.horas = item.horas;
        j.itens = [item];
        f.push(j);
        compare.push(item.id_refeicao);
      } else {
        f[index].itens.push(item);
      }
    });
    return f;
  },
  composicaoQuimicaCardapio: (array_) => {
    let referencia = array_.referencia;
    let valores = array_.valoresnutricionais;

    let diasref = [];

    for (var i = 0; i < 7; i++) {
      let ref = [];
      referencia.map((iten) => {
        let j = {
          id_elementoquimico: iten.id_elementoquimico,
          elemento: iten.elemento,
          necessidade: iten.referencia,
          realizado: 0,
        };
        if (iten.referencia > 0) {
          ref.push(j);
        }
      });
      diasref.push(ref);
    }

    let dias = [[], [], [], [], [], [], []];

    valores.map((iten) => {
      let j = {
        id_elementoquimico: iten.id_elementoquimico,
        elemento: iten.descricao,
        realizado: iten.referencia,
      };
      dias[iten.dia].push(j);
    });
    let diasf = [];
    dias.map((iten) => {
      let j = {};
      iten.map((e) => {
        j[e.id_elementoquimico] = e.realizado;
      });
      diasf.push(j);
    });
    let datagrafico = [[], [], [], [], [], [], []];
    for (var e = 0; e < 7; e++) {
      if (Object.keys(diasf[e]).length > 0) {
        diasref[e].map((iten) => {
          if (diasf[e][iten.id_elementoquimico]) {
            iten.realizado = diasf[e][iten.id_elementoquimico];
          }
          let at = [iten.elemento, parseFloat(iten.necessidade), parseFloat(iten.realizado)];
          datagrafico[e].push(at);
        });
      } else {
        diasref[e] = [];
      }
    }

    let resultado = {};
    resultado.composicao = diasref;
    resultado.chartdata = datagrafico;
    return resultado;
  },
  jsonDiasSemanaR: (index = false) => {
    let dias = [
      { num: -1, dia: "---" },
      { num: 0, dia: "Dom" },
      { num: 1, dia: "Seg" },
      { num: 2, dia: "Ter" },
      { num: 3, dia: "Qua" },
      { num: 4, dia: "Qui" },
      { num: 5, dia: "Sex" },
      { num: 6, dia: "Sab" },
    ];

    if (index !== false) return dias[index + 1].dia;
    return dias;
  },
  jsonDiasSemana: (index = false) => {
    let dias = [
      { num: -1, dia: "---" },
      { num: 0, dia: "Domingo" },
      { num: 1, dia: "Segunda-Feira" },
      { num: 2, dia: "Terça-Feira" },
      { num: 3, dia: "Quarta-Feira" },
      { num: 4, dia: "Quinta-Feira" },
      { num: 5, dia: "Sexta-Feira" },
      { num: 6, dia: "Sabado" },
    ];

    if (index !== false) return dias[index + 1].dia;
    return dias;
  },
  getDataHoje: () => {
    const dataAtual = new Date();
    const mes = (dataAtual.getMonth() + 1).toString().padStart(2, "0");
    const dia = dataAtual.getDate().toString().padStart(2, "0");
    const ano = dataAtual.getFullYear().toString();

    return `${ano}-${mes}-${dia}`;
  },
  getDatasDoMesAtual: () => {
    const dataAtual = new Date();
    const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
    const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);

    const diaDoPrimeiroDia = primeiroDiaDoMes.getDate().toString().padStart(2, "0");
    const mesDoPrimeiroDia = (primeiroDiaDoMes.getMonth() + 1).toString().padStart(2, "0");
    const anoDoPrimeiroDia = primeiroDiaDoMes.getFullYear().toString();

    const diaDoUltimoDia = ultimoDiaDoMes.getDate().toString().padStart(2, "0");
    const mesDoUltimoDia = (ultimoDiaDoMes.getMonth() + 1).toString().padStart(2, "0");
    const anoDoUltimoDia = ultimoDiaDoMes.getFullYear().toString();

    const dataDoPrimeiroDia = `${anoDoPrimeiroDia}-${mesDoPrimeiroDia}-${diaDoPrimeiroDia}`;
    const dataDoUltimoDia = `${anoDoUltimoDia}-${mesDoUltimoDia}-${diaDoUltimoDia}`;

    return { primeiroDia: dataDoPrimeiroDia, ultimoDia: dataDoUltimoDia };
  },
  notificarCardapioAlimentosSemana: (data, periodo = "na semana") => {
    let arr = [];
    data.map((iten) => {
      iten.notaalimento.map((it) => {
        if (parseInt(iten.minocorrencia) > 0) {
          if (parseInt(it.ocorrencia) < parseInt(iten.minocorrencia)) {
            arr.push(`O alimento ${it.alimento} deve ser servido no mínimo ${iten.minocorrencia} vezes ${periodo} !`);
          }
        }
        if (parseInt(iten.maxocorrencia) > 0) {
          if (parseInt(it.ocorrencia) > parseInt(iten.maxocorrencia)) {
            arr.push(`O alimento ${it.alimento} deve ser servido no máximo ${iten.maxocorrencia} vezes ${periodo} !`);
          }
        }
        if (parseFloat(iten.minpercapta) > 0) {
          if (parseFloat(it.consumo) < parseFloat(iten.minpercapta)) {
            arr.push(
              `O alimento ${it.alimento} não atingiu a per capita minima de  ${
                iten.minpercapta * 1000
              } gr  ${periodo} !`
            );
          }
        }
        if (parseFloat(iten.maxpercapta) > 0) {
          if (parseFloat(it.consumo) > parseFloat(iten.maxpercapta)) {
            arr.push(
              `O alimento ${it.alimento} ultrapassou a per capita máxima de  ${
                iten.maxpercapta * 1000
              } Gr  ${periodo} !`
            );
          }
        }
      });
    });

    return arr;
  },
  hoje: () => {
    const date = new Date(); // cria um objeto de data com a data atual
    const month = date.getMonth() + 1; // obtém o mês atual (lembre-se que os meses começam do zero)
    const day = date.getDate(); // obtém o dia atual
    const year = date.getFullYear(); // obtém o ano atual

    // formata a data como uma string no formato MM/DD/YYYY
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  },
  notificarCardapioGruposSemana: (data, periodo = "na semana") => {
    let arr = [];
    data.map((iten) => {
      iten.notagrupo.map((it) => {
        if (parseInt(iten.minocorrencia) > 0) {
          if (parseInt(it.ocorrencia) < parseInt(iten.minocorrencia)) {
            arr.push(`O grupo ${it.grupo} deve ser servido no mínimo ${iten.minocorrencia} vezes ${periodo} !`);
          }
        }
        if (parseInt(iten.maxocorrencia) > 0) {
          if (parseInt(it.ocorrencia) > parseInt(iten.maxocorrencia)) {
            arr.push(`O grupo ${it.grupo} deve ser servido no máximo ${iten.maxocorrencia} vezes ${periodo} !`);
          }
        }
        if (parseFloat(iten.minpercapta) > 0) {
          if (parseFloat(it.consumo) < parseFloat(iten.minpercapta)) {
            arr.push(
              `O grupo ${it.grupo} não atingiu a per capita minima de  ${iten.minpercapta * 1000} gr  ${periodo} !`
            );
          }
        }
        if (parseFloat(iten.maxpercapta) > 0) {
          if (parseFloat(it.consumo) > parseFloat(iten.maxpercapta)) {
            arr.push(
              `O grupo ${it.grupo} ultrapassou a per capita máxima de  ${iten.maxpercapta * 1000} Gr  ${periodo} !`
            );
          }
        }
      });
    });

    return arr;
  },

  mes: [
    "JANEIRO",
    "FEVEREIRO",
    "MARÇO",
    "ABRIL",
    "MAIO",
    "JUNHO",
    "JULHO",
    "AGOSTO",
    "SETEMBRO",
    "OUTUBRO",
    "NOVEMBRO",
    "DEZEMBRO",
  ],

  jsonMes: [
    { mes: "---", index: "" },
    { mes: "JANEIRO", index: "1" },
    { mes: "FEVEREIRO", index: "2" },
    { mes: "MARÇO", index: "3" },
    { mes: "ABRIL", index: "4" },
    { mes: "MAIO", index: "5" },
    { mes: "JUNHO", index: "6" },
    { mes: "JULHO", index: "7" },
    { mes: "AGOSTO", index: "8" },
    { mes: "SETEMBRO", index: "9" },
    { mes: "OUTUBRO", index: "10" },
    { mes: "NOVEMBRO", index: "11" },
    { mes: "DEZEMBRO", index: "12" },
  ],

  httpStatus: {
    200: {
      tipo: "success",
      icone: "mdi-check-bold",
      mensagem: "Sucesso",
    },
    400: {
      tipo: "error",
      icone: "mdi-alert-circle",
      mensagem: "Preencha os campos obrigatórios",
    },
    404: {
      tipo: "warning",
      icone: "mdi-alert",
      mensagem: "Não encontrado",
    },
    500: {
      tipo: "error",
      icone: "mdi-alert-circle",
      mensagem: "Ocorreu um erro interno",
    },
  },
  corPreenchido: (json, chave, leng = 0) => {
    let tx = "blak--text";

    if (typeof json == "object") {
      json[chave] == null ? (json[chave] = "") : null;
      if (json[chave].length == leng) {
        tx = "red--text text--accent-2";
      }
    }
    return tx;
  },

  semanasPeriodo: (data) => {
    let j = data;

    let js = {};
    for (var i = 0; i < 12; i++) {
      js[i] = [];
    }

    j.map((iten) => {
      let idx = parseInt(iten.mes) - 1;
      while (iten.length < 5) {
        iten.push({
          id: "...",
          ordem: "...",
          mes: "...",
          semana: "...",
          inicio: "...",
          fim: "...",
        });
      }
      js[idx].push(iten);
    });

    let ar = [];
    for (var i_ = 0; i_ < 12; i_++) {
      if (js[i_]) {
        while (js[i_].length < 5) {
          js[i_].push({ id: "", ordem: "", inici: "", fim: "" });
        }
        ar.push(js[i_]);
      }
    }
    return ar;
  },
  keysObrigatorios: (paramter, json) => {
    let ar = [];
    paramter.map((it) => {
      if (String(json[it.key]).length == 0) {
        ar.push(`É obrigatório preencher o campo  ${it.label} !`);
      }
    });
    return ar;
  },
  totalizarRomaneio(array, keyA, keyB) {
    // sum data in give key (property)
    return array.reduce((a, b) => a + (b[keyA] * b[keyB] || 0), 0);
  },
  nextInput(e, value, identifier) {
    const inputs = e.target?.ownerDocument?.querySelector(`.${identifier}`).querySelectorAll(value);

    const focusOn = (index, increase) => {
      let newIndex = index + increase;
      if (newIndex < 0) {
        focusOn(inputs.length, increase);
      } else if (newIndex > inputs.length - 1) {
        focusOn(0, 0);
      } else {
        inputs[newIndex].focus();
        if (inputs[newIndex] !== document.activeElement) focusOn(newIndex, increase);
      }
    };

    const changeTo = {
      previous: () => {
        inputs.forEach((input, index) => {
          if (input === e.target) index - 1 < 0 ? focusOn(inputs.length, -1) : focusOn(index, -1);
        });
      },
      next: () => {
        inputs.forEach((input, index) => {
          if (input === e.target) {
            index + 1 >= inputs.length ? focusOn(0, 0) : focusOn(index, +1);
          }
        });
      },
    };

    const keys = {
      ["Enter"]: () => changeTo.next(),
      ["ArrowUp"]: () => changeTo.previous(),
      ["ArrowDown"]: () => changeTo.next(),
    };

    try {
      keys[e.key]();
    } catch (e) {
      return;
    }
  },
  newPDF: (list, settings) => {
    if (!settings.accept)
      return console.error(
        'Você deve passar o atributo "accept" com um array de valores contendo os atributos que deseja'
      );

    let doc = new jsPDF({
      orientation: "landscape",
      unit: "cm",
    });

    const pageConfig = {
      // head: [],
      body: list,
      columns: [],
      // theme: 'grid',
      headStyles: {
        valign: "middle",
        fillColor: [0, 96, 100],
      },

      styles: {
        fontSize: 9,
        // lineWidth: 1,
        // overflow: 'ellipsize',
      },
    };

    settings.accept.forEach((att, index) =>
      pageConfig.columns.push({
        header: settings.rename[index],
        dataKey: att,
      })
    );

    doc.autoTable(pageConfig);

    // return doc.output('dataurlnewwindow', { filename: settings.filename || 'Tabela_G-ase' })
    return doc.output("save", settings.filename || "Tabela_G-ase");
  },
  newExcel(list, settings) {
    const accept = () =>
      list.map((item) => {
        let args = {};
        settings.accept.forEach((arg) => (args = { ...args, [arg]: item[arg] ?? "" }));
        return args;
      });

    const options = {
      fieldSeparator: ";",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: settings.rename?.length > 0 ? false : true,
      headers: settings.rename || [],
      filename: settings.filename || "Tabela_G-ase",
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(accept());
  },
  capitalize(value, default_split = " ") {
    if (value === null) return value;
    value = value.toLowerCase().split(default_split);
    return value.map((param) => param.charAt(0).toUpperCase().concat(param.slice(1))).join(default_split);
  },
  validate(array, key) {
    let retorno = null;
    array.includes(key) ? (retorno = "color: red;") : false;
    return retorno;
  },
  medidacaseira(num) {
    num = String(num);

    let ret = 0;
    let ac = false;
    let segundo = "";
    let primeiro = "";
    let ar = num.split(".");
    if (ar.length == 2) {
      ret = ar[1][0];
      ret == "0" ? (segundo = "") : null;
      ret == "5" ? (segundo = "1/2") : null;
      let nn = parseInt(ret);
      nn > 5 && nn < 7 ? (segundo = "1/2") : null;
      nn > 7 ? (ac = true) : null;
      let n1 = parseFloat(ar[0]);

      if (n1 == 0 && ac == true) {
        primeiro = "1";
      }
      if (n1 > 0 && ac == true) {
        let h = parseInt(n1);
        h = h + 1;
        primeiro = String(h);
      }
      if (n1 > 0 && ac == false) {
        primeiro = String(n1);
      }
    } else {
      primeiro = String(ar[0]);
    }
    return `${primeiro} ${segundo}`;
  },
  arrayContain(array = Array(), searchs = Array()) {
    let r = searchs.some((iten) => array.includes(iten));
    return r;
  },
  getSelectOptions(array) {
    let ar = [[], []];
    let ret = [];
    array.map((iten) => {
      if (parseInt(iten.ativo) == 1) {
        ar[0].push(iten);
      } else {
        ar[1].push(iten);
      }
    });

    if (ar[0].length > 0) {
      ret.push({ header: "Ativos" });
      ar[0].map((it) => {
        ret.push(it);
      });
    }
    if (ar[1].length > 0) {
      ret.push({ header: "Inativos" });
      ar[1].map((it) => {
        ret.push(it);
      });
    }
    return ret;
  },

  isDate(dateString) {
    let isValidDate = "";
    typeof dateString !== "string" ? (isValidDate = false) : (isValidDate = true);
    if (isValidDate) {
      const dateObject = new Date(dateString);
      isValidDate = !isNaN(dateObject.getTime());
    }
    return isValidDate;
  },

  pegarNomeSemana(semana) {
    return `${semana.ordem}ª semana de ${filters.dateBr(semana.inicio)} até ${filters.dateBr(semana.fim)}`;
  },
  clearInputClass(classe) {
    var els = document.getElementsByClassName(classe);
    for (var i = 0; i < els.length; i++) {
      els[i].value = "";
    }
  },
  setModulos(params) {
    let f = params.getters.acessofornecedor.length;
    let m = params.getters.acessomodulo.length;
    let i = params.getters.acessoinstituicao.length;
    if (f + m + i === 0) {
      let js = { id: "", id_municipio: "" };
      let jst = {};
      let payloadToken = this.getPayloadToken();
      jst = payloadToken || {};
      this.jsonReplaceValue(js, jst);
      let json = {
        id_usuario: js.id || "",
        id_municipio: js.id_municipio || "",
      };

      // Separa modulos em grupos
      let siglasGrupos = { nu: "ae", ae: "ae" };
      let grupos = [
        {
          descricao: "Alimentação Escolar",
          sigla: "ae",
          grupo: true,
          ativo: false,
          items: [],
        },
      ];

      if (json.id_usuario.length > 0) {
        params.actions.loadacessouser(json).then((response) => {
          let jsr = response.data;

          let Jf_ = jsr.modulos.filter((i) => {
            if (i.ativo == true) return i;
          });
          jsr.modulos = Jf_;

          if (jsr.modulos.length > 0) {
            jsr.modulos.map((modulo) => (modulo.grupo = siglasGrupos[modulo.sigla.toLowerCase()] || false));
            let semGrupo = jsr.modulos.filter((modulo) => !modulo.grupo);
            let comGrupo = jsr.modulos.filter((modulo) => modulo.grupo);
            let gruposModulos = {};
            comGrupo.forEach((modulo) => {
              let moduloGrupo = gruposModulos[modulo.grupo.toLowerCase()] ?? [];
              gruposModulos[modulo.grupo.toLowerCase()] = [...moduloGrupo, modulo];
            });
            grupos.map((grupo) => (grupo.items = gruposModulos[grupo.sigla.toLowerCase()]));
            jsr.modulos = semGrupo.concat(grupos);
          }

          params.mutations.setlistfornecedor(jsr.fornecedor);
          params.mutations.setlistmodulo(jsr.modulos);
          params.mutations.setlistinstituicao(jsr.instituicao);
        });
      }
    }
  },
  filtrarEgressos(chave, lista, dados) {
    // Retorna os valores (inseridos) da chave na lista
    let inseridos = lista.map((item) => item[chave]);

    let egressos = dados.filter((item) => {
      if (!inseridos.includes(item.id)) {
        return item;
      }
    });

    return egressos;
  },
  async pdf_generator(dados, settings = {}) {
    /**
     *      Paramêtro dados:
     *
     * { *** Para tabelas
     *      lista: [array] *,
     *      aceitar: [array] *,
     *      renomear: [array] *,
     *      padding: {left: 0, right: 0, top: 0, bottom: 0},
     *      tipo: 'image'|'table'|'text',
     *      styles: {
     *          font: 'helvetica'|'times'|'courier' = 'helvetica'
     *          fontStyle: 'normal'|'bold'|'italic'|'bolditalic' = 'normal'
     *          overflow: 'linebreak'|'ellipsize'|'visible'|'hidden' = 'linebreak'
     *          fillColor: Color? = null
     *          textColor: Color? = 20
     *          cellWidth: 'auto'|'wrap'|number = 'auto'
     *          minCellWidth: number? = 10
     *          minCellHeight: number = 0
     *          halign: 'left'|'center'|'right' = 'left'
     *          valign: 'top'|'middle'|'bottom' = 'top'
     *          fontSize: number = 10
     *          cellPadding: Padding = 10
     *          lineColor: Color = 10
     *          lineWidth: number = 0
     *      },
     * },
     * { *** Para imagens:
     *      canvas: canvas * (não usar imageURL),
     *      imageURL: string * (não usar canvas),
     *      tipo: 'image' *,
     *      width: number = 100 (% do tamanho da página),
     *      posLastY: Number = 0, (espaçamento do último elemento inserida),
     *      posX: Number = auto,
     *      posY: Number = auto,
     *      align: 'left'|'center'|'right' = 'left',
     * }
     */

    /**
     *      Paramêtro settings:
     *
     * {
     *  orientation: 'portrait'|'landscape' = 'portrait',
     *  filename: String = 'G-ase',
     *  headers: [
     *      {
     *          canvas: canvas * (não usar imageURL),
     *          imageURL: string * (não usar canvas),
     *          width: number = 100 (% do tamanho da página),
     *          posLastY: Number = 0, (espaçamento do último elemento inserida),
     *          posX: Number = auto,
     *          posY: Number = auto,
     *          align: 'left'|'center'|'right' = 'left',
     *      },
     *      {
     *          text: String *,
     *          font: 'helvetica'|'times'|'courier' = 'helvetica',
     *          fontSize: Number = 13,
     *          padding: {left: 0, right: 0, top: 0, bottom: 0},
     *          align: 'left'|'center'|'right' = 'center',
     *      }
     *  ],
     *  footers: [
     *      {
     *          text: String *,
     *          align: 'left'|'center'|'right' = 'left',
     *      }
     *  ],
     *  footerEveryPage: Boolean = true,
     * }
     */

    if (!dados) return console.error("É necessário passar um ou mais dados");

    let doc = new jsPDF({
      orientation: settings.orientation || "p",
      unit: "px",
      format: "a4",
    });

    // Valor da margem
    const marginValue = 40;
    // Armazena a ultima posição do elemento inserido (inicia com o valor da margem)
    let y_pos = marginValue;
    // Armazena a página do ultimo elemento inserido
    let lastPageNumber = 1;
    // Acrescenta um tamanho para modificar a útlima posição + um espaçamento
    const novaPosicaoY = (pos, padding = 0) => {
      if (y_pos > doc.internal.pageSize.height - marginValue * 2) {
        doc.addPage();
        return (y_pos = marginValue);
      }
      y_pos += pos + padding;
    };

    // Retorna a posição mais alta (y_pos ou a última tabela inserida)
    function pegarUltimaPosicaoY(padding = 0) {
      let lastTable = doc.lastAutoTable;
      if (lastTable.startPageNumber > lastPageNumber) y_pos = 5;
      if (lastTable.finalY && lastTable.finalY > y_pos) y_pos = lastTable.finalY;
      return (y_pos += padding);
    }

    // Aqui sera feito as estilizações da tabela
    function novaConfiguracao(info = {}) {
      const configuracao = {
        body: info.lista,
        columns: [],
        theme: info.theme || "plain",
        headStyles: {
          valign: "middle",
          ...info.headStyles,
        },
        startY: pegarUltimaPosicaoY(info.padding?.top || 0),
        pageBreak: "avoid",
        margin: marginValue,
        styles: {
          fontSize: 8,
          lineColor: "#ccc",
          lineWidth: 0.8,
          ...info.styles,
        },
        columnStyles: {
          ...info.columnStyles,
        },
      };

      info.aceitar.forEach((att, index) =>
        configuracao.columns.push({
          header: info.renomear[index],
          dataKey: att,
        })
      );

      return configuracao;
    }

    function inserirImagem(config) {
      return new Promise((resolve, reject) => {
        configurar();

        function configurar() {
          if (config.imageURL) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            let img = new Image();
            img.src = config.imageURL;
            img.onload = () => {
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              config.canvas = canvas;
              inserir();
            };
          } else {
            inserir();
          }
        }

        function inserir() {
          var imgData = config.canvas?.toDataURL("image/png");
          var { w, h } = pegarNovaDimensao();
          let { x, y } = pegarPosicaoImagem();
          doc.addImage(imgData, "JPEG", x, y, w, h);
          if (!config.float) novaPosicaoY(h, config.padding?.bottom || 5);

          function pegarNovaDimensao() {
            if (!config.canvas) reject();
            let { height, width } = config.canvas;
            let razao = height / width;
            let pgSize = doc.internal.pageSize;
            let dim_w = config.width // % do tamanho da página
              ? config.width * 0.01 * (pgSize.width - marginValue * 2)
              : false;
            let dim_h = config.height || false; // Pixel
            return {
              w: dim_w || dim_h * razao,
              h: dim_h || dim_w * razao,
            };
          }

          function pegarPosicaoImagem() {
            let align = config.align?.toLowerCase() || "left";
            let xAxle = config.posX || marginValue;
            if (align === "center") xAxle = (doc.internal.pageSize.width - w) / 2;
            if (align === "right") xAxle = doc.internal.pageSize.width - w - marginValue;
            return {
              x: xAxle,
              y: config.posY || pegarUltimaPosicaoY(config.padding?.top || 5),
            };
          }

          resolve();
        }
      });
    }

    function pegarAlinhamento(align = "left", padding = {}) {
      const alignments = {
        left: marginValue + (padding.left || 0),
        center: (doc.internal.pageSize.width - marginValue * 2) / 2,
        right: doc.internal.pageSize.width - marginValue - (padding.right || 0),
      };

      return alignments[align];
    }

    // Se existir um cabecalho
    if (settings.headers) {
      doc.setPage(0);
      for (let header of settings.headers) {
        if (header.text) {
          let fontSize = header.fontSize || 13;
          doc.setFontSize(fontSize);
          doc.text(
            header.text,
            pegarAlinhamento(header.align, header.padding),
            pegarUltimaPosicaoY(header.padding?.top || 0) + fontSize,
            header.align || "center"
          );
          novaPosicaoY(fontSize, header.padding?.bottom || 0);
        } else {
          await inserirImagem(header);
        }
      }
      doc.line(marginValue, pegarUltimaPosicaoY(), doc.internal.pageSize.width - marginValue, pegarUltimaPosicaoY());
      novaPosicaoY(1, 5);
    }

    for (let dado of dados) {
      const executar = {
        is_table: () => doc.autoTable(novaConfiguracao(dado)),
        is_image: async () => await inserirImagem(dado),
      };

      await executar[`is_${dado.tipo || "table"}`]();
    }

    // Se não existir um rodapé, crie um
    if (!settings.footers)
      settings.footers = [
        {
          text: "G-ase",
          align: "left",
        },
        {
          text: "Página",
          align: "center",
          pageCount: true,
        },
        {
          text: "Impresso em",
          align: "right",
          datetime: true,
        },
      ];

    let numeroPaginas = doc.internal.getNumberOfPages();
    if (settings.footerEveryPage == false) numeroPaginas = 1;
    for (let p = 1; p <= numeroPaginas; p++) {
      doc.setPage(p);
      doc.setFontSize(8);
      doc.line(
        marginValue,
        doc.internal.pageSize.height - marginValue + 3,
        doc.internal.pageSize.width - marginValue,
        doc.internal.pageSize.height - marginValue + 3
      );
      settings.footers.forEach((footer) => {
        doc.text(
          footer.text + (footer.pageCount ? ` ${p}` : "") + (footer.datetime ? ` ${new Date().toLocaleString()}` : ""),
          pegarAlinhamento(footer.align || "center", footer.padding),
          doc.internal.pageSize.height - marginValue,
          footer.align || "center"
        );
      });
    }

    return doc.output("save", `${settings.filename || "G-ase"}.pdf`);
  },
  esperarTempo(delay) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(new Date().toLocaleString());
      }, delay || 0);
    });
  },
  transformarEmObjeto(listas) {
    let objetos = {};
    listas.forEach(([lista, chave, nome_atributo]) => {
      let objeto = {};
      lista.forEach((att) => (objeto[att[chave]] = att));
      objetos[nome_atributo] = objeto;
    });
    return objetos;
  },
  html2pdf(html, filename = "g-ase") {
    html2canvas(html, {
      allowTaint: true,
      useCORS: true,
      dpi: 3,
      scale: 3,
      width: 1366,
    }).then((canvas) => {
      let imgData = canvas.toDataURL("image/png");
      let [w, h] = [canvas.width, canvas.height];
      let doc = new jsPDF("L", "px", [w, h]);
      doc.addImage(imgData, "JPEG", 10, 10, w, h);
      return doc.save(filename.concat(".pdf"));
    });
  },
  /**
   *
   * @param {*} object Array de objetos
   * @param {*} array array com nomes doas fields  exemplo ["id_cardapio", "cardapio"]
   * @returns
   */
  prependObject(object, array, value = "", text = "......") {
    let obj = {};
    obj[array[0]] = value;
    obj[array[1]] = text;
    object.unshift(obj);
    return object;
  },
  concatKeyObject(object, key, array) {
    object.map((i) => {
      let newstr = "";
      array.map((e) => {
        if (newstr == "") {
          newstr += i[e];
        } else {
          newstr += ` - ${i[e]}`;
        }
      });
      i[key] = newstr;
    });

    return object;
  },
  keyExistsJson(json, keys) {
    let t = true;
    keys.map((i) => {
      if (i in json) {
        null;
      } else {
        t = false;
      }
    });
    return t;
  },
  async carregarDados(requester, from, params = {}) {
    return await requester({ path: from, params });
  },
  requisitar(requester, lista, setar) {
    lista.forEach(async (item) => {
      let renomear = typeof item[0] == "object" ? item[0][1] : false;
      let nome = renomear ? item[0][0] : item[0];
      try {
        let dados = await this.carregarDados(requester, nome, item[1] || {});
        setar({ [renomear || nome]: dados });
      } catch (e) {
        console.error("Houve um erro na requisição.", e);
      }
    });
  },
  pegarMediaComposicao(listaDiasComposicao = []) {
    let arrElementosComposicao = [];
    let refIdAlimento = {};
    let medias = {};

    // Passa por cada dia, e para cada dia, pega os elementos
    listaDiasComposicao.forEach((dia, i) => {
      let nomeDia = this.jsonDiasSemanaR(i);
      dia.forEach((elemento) => {
        let id = elemento.id_elementoquimico;
        let nomeAlimento = elemento.elemento;
        refIdAlimento[id] = nomeAlimento;
        // Adicionando o elemento a lista de acordo com o dia
        arrElementosComposicao[i] = {
          ...arrElementosComposicao[i],
          param: nomeDia,
          [id]: Number(elemento.realizado).toFixed(2),
        };
        // Incrementando a média mensal do elemento
        medias[id] = (medias[id] || 0.0) + Number(elemento.realizado);
      });
    });
    /**
     * Retiramos os dias sem elementos químicos
     */
    for (let i = arrElementosComposicao.length - 1; i >= 0; i--) {
      arrElementosComposicao[i] == undefined ? arrElementosComposicao.splice(i, 1) : null;
    }

    // Calculando a média mensal de cada elemento e fixando duas casas após a vírgula
    Object.entries(medias).forEach(
      ([id, media]) => (medias[id] = Number(media / arrElementosComposicao.length).toFixed(2))
    );

    // Adicionando a média mensal ao array de elementos como uma linha
    arrElementosComposicao.push({
      param: "Média semanal",
      ...medias,
    });

    // Cria arrays para retornar
    let aceitar = ["param"];
    let renomear = ["Composição Nutricional"];

    // ordem refIdAlimento por ID:
    let order = [29, 24, 52, 40, 68, 66, 23, 32];

    // Ordenando os elementos
    order.forEach((id) => {
      if (refIdAlimento[id]) {
        aceitar.push(id);
        renomear.push(refIdAlimento[id]);
      }
    });

    return {
      lista: arrElementosComposicao,
      aceitar,
      renomear,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      columnStyles: {
        // Estilizando a coluna "Composição Nutricional" para parecer um cabecalho
        param: {
          fontStyle: "bold",
          textColor: 15,
          cellWidth: 80,
        },
      },
    };
  },
  handleError(error) {
    console.error(error);
    return error;
  },
  groupBy(list, attr, backItem = false, backList = false) {
    const map = new Map();
    list.forEach((item) => {
      const key = `${attr}:${item[attr]}`;
      const collection = map.get(key);

      if (!collection) map.set(key, [item]);
      else collection.push(item);

      if (backItem) backItem(key, item);
    });
    if (backList) backList(map);
    return map;
  },
  html_pdf(pages = [], settings = {}, callback = () => {}) {
    return new Promise((success, fail) => {
      (async function () {
        if (!pages || pages.length === 0) fail("Nenhuma página para gerar o PDF");
        if (typeof settings != "object") fail("O parâmetro settings deve ser um objeto");
        if (typeof callback != "function") fail("O parâmetro callback deve ser uma função");

        // pages<Array> => [html, html]
        // settings<Object> => {..}

        // settings params:
        // windowWidth<Number> : default 800
        // width<Number> : default windowWidth
        // orientation<String> (portrait|landscape) : default portrait
        // filename<String> : default "g-ase-doc.pdf"
        // margin<Number> : default 20
        // _stop_on_error<Boolean> : default false

        // callback<Function> => function(err, page)

        // callback return:
        // err<Object> => { error: '', message: '' }
        // page<Object> => {}

        // page params:
        // _page_number<Number>
        // _page_count<Number>
        // _loading<Boolean>
        // _loading_message<String> : default "Gerando páginas..."
        // _loading_progress<Number>

        // promise return:
        // success<Then> => <Array> => [doc<Object>, filename<String>]
        // error<Catch> => (err, page_info)

        settings = {
          windowWidth: settings.windowWidth || 800,
          width: settings.width || settings.windowWidth,
          orientation: settings.orientation || "portrait",
          filename: settings.filename || "g-ase-doc.pdf",
          margin: settings.margin || 20,
          ...settings,

          _global: {
            _y_position: settings.margin || 20,
          },
        };

        let doc = new jsPDF({
          orientation: settings.orientation || "portrait",
          unit: settings.unit || "px",
          format: settings.format || "a4",
        });

        function PageInfo(page_index) {
          const _loading_progress = (++page_index / pages.length) * 100;
          return {
            _page_number: page_index,
            _page_count: pages.length,
            _loading: _loading_progress < 100,
            _loading_message: "Gerando páginas...",
            _loading_progress,
          };
        }

        for (let [page_index, page] of pages.entries()) {
          const page_info = PageInfo(page_index);
          try {
            await insertPage(page).catch((err) => {
              callback(err, page_info);
              if (settings._stop_on_error) fail(err, page_info);
            });
            callback(false, page_info);
          } catch (e) {
            callback(
              {
                status: 500,
                message: "Erro desconhecido ao gerar página",
                _details: e,
              },
              page_info
            );
            if (settings._stop_on_error) fail(e, page_info);
          }
        }

        function insertPage(page) {
          return new Promise((resolve, reject) => {
            let clone = page.cloneNode(true);
            let page_clone = document.createElement("div");

            page_clone.style = {
              width: settings.width || settings.windowWidth,
              maxWidth: settings.width || settings.windowWidth,
            };

            page_clone.appendChild(clone);
            document.body.appendChild(page_clone);

            html2canvas(page_clone, {
              scale: 3,
              dpi: 300,
              width: settings.windowWidth,
              windowWidth: settings.windowWidth,
            })
              .then((canvas) => {
                let img = canvas.toDataURL("image/png");
                // don't forget to remove the element from the DOM
                document.body.removeChild(page_clone);
                try {
                  const new_width = doc.internal.pageSize.width - settings.margin * 2;
                  const new_height = new_width * (canvas.height / canvas.width);

                  // check if the page is too big to fit in the page,
                  // if so, create a new page or return an error
                  const can_insert = checkPageHeight(new_height);
                  if (!can_insert) reject(can_insert /** <Object> */);

                  doc.addImage(
                    img, // imageData
                    "PNG", // format
                    settings.margin, // x
                    settings._global._y_position, // y
                    new_width, // width
                    new_height // height (new width times ratio)
                  );

                  // sum the height of the image with a padding (second param)
                  sumPageHeight(new_height, 10);
                  resolve(true);
                } catch (e) {
                  reject({
                    status: 500,
                    message: "Erro ao inserir página",
                    _details: e,
                  });
                }
              })
              .catch((e) => {
                reject({
                  status: 500,
                  message: "Erro ao converter página para imagem",
                  _details: e,
                });
              });
          });
        }

        function sumPageHeight(height, padding = 10) {
          settings._global._y_position += height + padding;
        }

        function checkPageHeight(height = 0) {
          // if the page height is greater than the max height, we need to return a error
          let new_height = settings._global._y_position + height;
          let page_max_height = doc.internal.pageSize.height - settings.margin * 2;
          if (height > page_max_height) {
            // if the page height is greater than the max height, we need to return a error
            return {
              status: 500,
              message: "Página/elemento muito alta",
              _details: {
                height,
                page_max_height,
              },
            };
          }
          if (new_height > page_max_height) {
            if (Number(height) > 0) createNewPage();
            return false;
          }
        }

        function createNewPage() {
          doc.addPage();
          doc.setPage(doc.internal.getNumberOfPages());
          // reset the y position
          settings._global._y_position = settings.margin;
        }

        success([doc, settings.filename]);
      })();
    });
  },
  isValidDate(dateString) {
    // Verifica se a data foi fornecida no formato dd/mm/aaaa ou mm/dd/aaaa
    const datePatternBR = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const datePatternUS = /^(\d{2})-(\d{2})-(\d{4})$/;

    let dia, mes, ano;
    let datePattern;

    if (datePatternBR.test(dateString)) {
      datePattern = datePatternBR;
    } else if (datePatternUS.test(dateString)) {
      datePattern = datePatternUS;
    } else {
      // Se a data não corresponder a nenhum dos padrões, é inválida
      return false;
    }

    // Extrai os valores de dia, mês e ano da data fornecida
    [, dia, mes, ano] = datePattern.exec(dateString);

    // Converte as strings para números inteiros
    const diaInt = parseInt(dia, 10);
    const mesInt = parseInt(mes, 10);
    const anoInt = parseInt(ano, 10);

    // Verifica se os valores são numéricos e estão dentro dos intervalos válidos
    if (isNaN(diaInt) || isNaN(mesInt) || isNaN(anoInt)) {
      return false;
    }

    // Verifica se o mês está dentro do intervalo válido (1 a 12)
    if (mesInt < 1 || mesInt > 12) {
      return false;
    }

    // Verifica se o dia está dentro do intervalo válido para o mês fornecido
    const diasPorMes = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (mesInt === 2 && ((anoInt % 4 === 0 && anoInt % 100 !== 0) || anoInt % 400 === 0)) {
      // Se o ano for bissexto, fevereiro tem 29 dias
      if (diaInt < 1 || diaInt > 29) {
        return false;
      }
    } else {
      if (diaInt < 1 || diaInt > diasPorMes[mesInt - 1]) {
        return false;
      }
    }

    // Verifica se o ano está dentro de um intervalo razoável (por exemplo, não antes de 1900)
    const anoMinimo = 1900;
    const anoMaximo = new Date().getFullYear();
    if (anoInt < anoMinimo || anoInt > anoMaximo) {
      return false;
    }

    // A data é válida
    return true;
  },
  jsonToQueryString(obj) {
    // 1. Filtra propriedades válidas (remove undefined/null/empty)
    const validParams = Object.entries(obj).filter(([value]) => value !== undefined && value !== null && value !== "");

    // 2. Converte para query string
    const queryParams = validParams
      .map(([key, value]) => {
        // Converte arrays para formato repetido (ex: ids=1&ids=2)
        if (Array.isArray(value)) {
          return value.map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join("&");
        }
        // Converte objetos para JSON stringified (se necessário)
        if (typeof value === "object") {
          return `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`;
        }
        // Caso padrão (strings, números, booleanos)
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join("&");

    return queryParams ? `?${queryParams}` : "";
  },
};

export { Libs };
